import { FormControlLabel, Grid, Switch, Typography } from '@material-ui/core';
import {
  WorkflowSchedulingStage,
  WorkflowStageDetail,
} from 'api-clients/monolith';
import produce from 'immer';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { makeSelectWhoami } from 'containers/Auth_old/selectors';

import { StageSettingCard } from '../../../../StageSettingCard';
import { GoDisabledInfoTooltip } from '../GoDisabledInfoTooltip/GoDisabledInfoTooltip';
import { isWorkflowSchedulerStage } from '../schedulerStageTypeGuards';
import { LIVE_VIDEO_ENABLED } from './constants';
import { messages } from './messages';
import { useStyles } from './styles';

export interface LiveVideoCardProps {
  stage: WorkflowSchedulingStage;
  setStage: React.Dispatch<React.SetStateAction<WorkflowStageDetail>>;
}

export const LiveVideoCard: FC<LiveVideoCardProps> = ({ stage, setStage }) => {
  const styles = useStyles();
  const intl = useIntl();
  const whoami = useSelector(makeSelectWhoami());
  const isHireGoEnableLiveVideoInterviewEnabled = Boolean(
    whoami.feature_flags['hire-go-enable-live-video-interview'],
  );

  const { additional_info: additionalInfo } = stage;

  const onToggleChange = (key: typeof LIVE_VIDEO_ENABLED) => () => {
    setStage(
      produce(stage, draftStage => {
        if (draftStage.additional_info) {
          draftStage.additional_info[key] = !draftStage.additional_info[key];
        }
      }),
    );
  };

  const isLiveVideoDisabledDueToGoHosts =
    !isHireGoEnableLiveVideoInterviewEnabled &&
    Boolean(
      isWorkflowSchedulerStage(stage) &&
      stage.additional_info.use_go_hosts_for_interviewers,
    );

  return (
    <StageSettingCard
      variant="default"
      title={intl.formatMessage(messages.liveVideo)}
    >
      <Grid>
        <Typography variant="body2" className={styles.description}>
          {intl.formatMessage(messages.liveVideoDescription)}
          <a
            href="https://support.fountain.com/en/articles/9899557-live-video"
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage(messages.learnMore)}
          </a>
        </Typography>
      </Grid>
      <Grid className={styles.cardBody}>
        <Grid item xs={12} className={styles.fieldRow}>
          <Grid item xs={12} className={styles.fieldRow}>
            <FormControlLabel
              control={
                <Switch
                  disabled={isLiveVideoDisabledDueToGoHosts}
                  data-testid={LIVE_VIDEO_ENABLED}
                  checked={additionalInfo?.live_video_enabled}
                  onChange={onToggleChange(LIVE_VIDEO_ENABLED)}
                />
              }
              label={
                <Typography variant="body2" className={styles.switchLabel}>
                  {intl.formatMessage(messages.enableLiveVideoCall)}
                  {isLiveVideoDisabledDueToGoHosts && <GoDisabledInfoTooltip />}
                </Typography>
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </StageSettingCard>
  );
};
